import { render, staticRenderFns } from "./templates.vue?vue&type=template&id=515fafce&scoped=true"
import script from "./templates.vue?vue&type=script&lang=js"
export * from "./templates.vue?vue&type=script&lang=js"
import style0 from "./templates.vue?vue&type=style&index=0&id=515fafce&prod&scoped=true&lang=css"
import style1 from "./templates.vue?vue&type=style&index=1&id=515fafce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515fafce",
  null
  
)

export default component.exports